<template>
  <button
    v-if="sendToTelegramEnabled"
    type="button"
    :class="buttonClass"
    :title="s__('Attachments|Send to Telegram')"
    :disabled="disabled"
    @click="$emit('send')"
  >
    <MessageSquareIcon :size="iconSize" />
  </button>
</template>

<script setup>
import { computed } from 'vue'
import { s__ } from '@/locale'
import MessageSquareIcon from './icons/MessageSquareIcon.vue'

const props = defineProps({
  disabled: {
    type: Boolean,
    default: false,
  },
  iconSize: {
    type: Number,
    default: 16,
  },
  buttonClass: {
    type: String,
    default: 'btn-icon-action',
  },
})

defineEmits(['send'])

const sendToTelegramEnabled = computed(() => {
  return window.gon?.attachments_send_to_telegram_enabled !== false
})
</script>
